import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from 'esr-core/app'
import './index.css'
import { CONFIG } from "./config.ts";

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App config={CONFIG}/>
  </StrictMode>,
)
